const store = {
    namespaced: true,
    state: {
        partitions: [],
        associated_partitions: [],
        pagination: {
            current_page: null,
            total_pages: null,
        },
        materials: [],
        customers: [],
    },
    getters: {
        number_with_commas(state, getters, rootState, rootGetters) {
            return (number="") => {
                return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
        },
        current_customer(state, getters, rootState, rootGetters) {
            return (partition) => {
                return _.findLast(state.customers, customer => customer.identity == partition.customer_identity)
            }
        },
        current_material(state, getters, rootState, rootGetters) {
            return (partition) => {
                return _.findLast(state.materials, material => material.identity == partition.material_identity)
            }
        },
    },
    actions: {
        fetch_partitions(context, payload) {
            var rest_url = new RestUrl(context.rootState.provider.routes.api_v1_provider_partitions);
            var url = rest_url.parse(
                {},
                "?page=" + payload.page
            )

            return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    let partitions = _.remove(response.data.partitions, partition => {
                        return partition.parent_identity == null
                    });
                    context.commit('set_partitions', partitions)
                    context.commit('set_pagination', response.data.pagination)
                })
                .catch(error => {
                    console.log('Failed to fetch Partitions.');
                    return Promise.reject(error);
                });
        },
        fetch_associated_partitions(context, payload) {
            var rest_url = new RestUrl(context.rootState.provider.routes.api_v1_provider_associated_partitions);
            var url = rest_url.parse(
                {},
                "?page=" + payload.page
            )

            return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    context.commit('set_associated_partitions', response.data.associated_partitions)
                    context.commit('set_pagination', response.data.pagination)
                })
                .catch(error => {
                    console.log('Failed to fetch AssociatedPartitions.');
                    return Promise.reject(error);
                });
        },
        fetch_customers(context, payload) {
            var rest_url = new RestUrl(context.rootState.provider.routes.api_v1_provider_customers);
            var url = rest_url.parse(
                {},
                "?pagination=false"
            )

            return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    console.log(response);
                    context.commit('set_customers', response.data.customers)
                })
                .catch(error => {
                    console.log('Failed to fetch CustomerNodes.');
                    return Promise.reject(error);
                });
        },
        fetch_materials(context, payload) {
            var url = new RestUrl(context.rootState.provider.routes.api_v1_provider_materials).parse(
                {},
                "?pagination=false"
            );
            return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        context.commit('set_materials', response.data.materials)
                    } else {
                        console.log('Failed to fetch Material.');
                        return Promise.reject(error);
                    }
                })
        },
    },
    mutations: {
        set_associated_partitions(state, payload) {
            state.associated_partitions = payload;
        },
        set_partitions(state, payload) {
            state.partitions = payload;
        },
        set_pagination(state, payload) {
            state.pagination = payload;
        },
        set_customers(state, payload) {
            state.customers = payload;
        },
        set_materials(state, payload) {
            state.materials = payload;
        },
        add_partition(state, payload) {
            state.partitions.push(payload)
        },
        update_partition(state, payload) {
            let index = _.findIndex(state.partitions, partition => partition.identity == payload.identity)
            state.partitions.splice(index, 1, payload)
        },
        remove_partition(state, payload) {
            let index = _.findIndex(state.partitions, partition => partition.identity == payload.identity)
            state.partitions.splice(index, 1)
        },
    }
}

export default store
